// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/actiontext")
require("@rails/activestorage").start()
require("@rails/ujs").start()
require("channels")
require("trix")
// require("flatpickr")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

// https://medium.com/swlh/integrate-bootstrap-4-and-font-awesome-5-in-rails-6-fec52ee51753
import 'bootstrap'
import 'bootstrap-datepicker'
import 'bootstrap-select'
import '@fortawesome/fontawesome-free/js/all.min'
// import 'jquery-mask-plugin'

// NOTE: keep these above '../stylesheets/application' import, so that
//       javascript/stylesheets/app/fullcalendar_custom.scss custom stylesheet
//       loads after these and overrides the default fullcalendar CSS styles.
// https://stackoverflow.com/questions/60587433/fullcalendar-io-css-not-working-in-rails-6-app
window.Calendar = require("@fullcalendar/core").Calendar;
window.dayGridPlugin = require("@fullcalendar/daygrid").default;
window.timeGridPlugin = require("@fullcalendar/timegrid").default;
window.listPlugin = require("@fullcalendar/list").default;
// window.bootstrap5Plugin = require("@fullcalendar/bootstrap5").default;

import '../stylesheets/application'
import '../app/configure-plugins'
import '../app/base'

// document.addEventListener("turbolinks:load", () => {
//   $('[data-toggle="tooltip"]').tooltip()
// })

// TODO: refactor into own file (similar to "configure-plugins.js")
// https://blog.capsens.eu/how-to-write-javascript-in-rails-6-webpacker-yarn-and-sprockets-cdf990387463
// https://getbootstrap.com/docs/4.4/components/forms/#file-browser
// https://www.npmjs.com/package/bs-custom-file-input
import bsCustomFileInput from 'bs-custom-file-input'
$(function() {
  bsCustomFileInput.init();
})
